import { DELETE_NEWS_LOADING, DELETE_NEWS_SUCCESS, DELETE_NEWS_ERROR } from "../../../constant/actionTypes";

const deleteNewsReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_NEWS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case DELETE_NEWS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case DELETE_NEWS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default deleteNewsReducer;